import dynamic from 'next/dynamic';
import LinearProgress from '@mui/material/LinearProgress';
import { Styles } from '@t2c/shared-fe';
import Layout from '../components/layouts';
import { LandingPage } from '../components';

export default function Home() {
  return <LandingPage />;
}

const style: Styles = {
  wrapperSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
